import { MarketingTriggerKey } from "@redotech/redo-model/advanced-flow/triggers";
import { SortDirection } from "@redotech/redo-model/tables/table";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getConversationLogs = {
  name: "getConversationLogs" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(20),
    sortKey: z
      .enum(["lastMessageAt", "lastInitialMessageAt"])
      .default("lastMessageAt"),
    sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
    searchString: z.string().optional(),
    hasInboundMessage: z.boolean().optional(),
    teamId: zExt.objectId().optional(),
    triggerKeys: z.array(createEnum(MarketingTriggerKey)).optional(),
  }),
  output: z.object({
    conversations: z.array(
      z.object({
        _id: z.string(),
        teamId: z.string(),
        teamName: z.string().optional(),
        customerName: z.string().optional(),
        lastMessageAt: z.date().optional(),
        lastInitialMessageAt: z.date().optional(),
        messageCount: z.number(),
        automation: z
          .object({
            automationName: z.string().optional(),
            stepLabel: z.string().optional(),
          })
          .optional(),
      }),
    ),
    totalCount: z.number(),
  }),
};
